import { useMemo, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import Differentiators from "./components/Differentiators";
import MenuDiscovery from "./components/MenuDiscovery";
import MenuSummary from "./components/MenuSummary";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import SocialProof from "./components/SocialProof";
import BrandStory from "./components/BrandStory";
import FarmToTable from "./components/FarmToTable";
import Certificates from "./components/Certificates";
import RegionCheck from "./components/RegionCheck";
import Corporate from "./components/Corporate";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import MobileStickyBar from "./components/MobileStickyBar";
import ExitPopup from "./components/ExitPopup";
import { dishes } from "../../mocks/home";

export default function Home() {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const toggleDish = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const clearDishes = () => setSelectedIds([]);

  const selectedDishes = useMemo(
    () => dishes.filter((d) => selectedIds.includes(d.id)),
    [selectedIds]
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Differentiators />

        {/* Interactive menu section */}
        <section id="menu" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto">
              <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
                Menü Özgürlüğü
              </span>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
                CANIN NE ÇEKERSE ONU SEÇ.
              </h2>
              <p className="mt-4 text-foreground-600 leading-relaxed">
                Tek bir seçeneğe mahkûm değilsin. Menüdeki alternatiflerden kendi
                öğününü oluştur.
              </p>
              <span className="mt-3 inline-block text-[11px] font-semibold text-foreground-400 bg-background-100 px-3 py-1 rounded-full">
                Örnek içerik — gerçek menü verisi bağlandığında güncellenecek
              </span>
            </div>

            <div className="mt-10 grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-8 lg:gap-10 items-start">
              <MenuDiscovery selectedIds={selectedIds} onToggle={toggleDish} />
              <MenuSummary selectedDishes={selectedDishes} onClear={clearDishes} />
            </div>
          </div>
        </section>

        <HowItWorks />
        <Pricing />
        <SocialProof />
        <BrandStory />
        <FarmToTable />
        <Certificates />
        <RegionCheck />
        <Corporate />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <MobileStickyBar />
      <ExitPopup />
    </div>
  );
}